import React, { FC } from "react"

import MainLayout from "../../common/components/layouts/MainLayout"
import PageHead from "../../common/components/page-header/PageHeader"
import FavoritePage from "../../common/components/pages/favorite/FavoritePage"

const Favorites: FC = () => {
    return (
    <MainLayout pageTitle="Избранное">
      <div className="page-wrapper">
         <PageHead title="Избранное" />

        <FavoritePage />
      </div>
    </MainLayout>
    )
}

export default Favorites
